<template>
  <div class="game-section">
    <section-heading :text="content.heading" />
    <p class="image-holder">
      <img class="image" :src="require(`@/assets/${content.image}`)" />
    </p>
    <p class="text" v-html="content.text1"></p>
    <p class="image-holder">
      <img class="image" :src="require(`@/assets/${content.image2}`)" />
    </p>
    <p class="text" v-html="content.text2"></p>
    <game :allowPlaying="allowPlaying" />
    <p class="text text-end" v-html="content.endtext"></p>
    <collapsable-box
      title="Meer over echolocatie"
      text="Met behulp van echolocatie spoort een bruinvis zijn prooi op en vindt hij zijn weg in de donkere zee. Via een speciaal orgaan in het hoofd, een akoestische lens, bundelt hij het geluid en zendt het naar voren uit. Dat kaatst terug op bijvoorbeeld een vis en komt via de kaak terug in het oor van de bruinvis. Met zijn gehoor kan hij zo 'zien'."
    />
  </div>
</template>
<script>

import Game from '../components/Game'
import CollapsableBox from '../components/CollapsableBox'
import SectionHeading from '../components/SectionHeading'
import { trackSection } from '../utils/track.js'

export default {
  components: {
    Game,
    CollapsableBox,
    SectionHeading
  },
  props: {
    content: {
      type: Object,
      default: () => {}
    },
    id: {
      type: String,
      default: ''
    },
    tracking: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      allowPlaying: false,
      tracked: false
    }
  },
  mounted () {
    window.addEventListener('scroll', () => {
      this.checkIfPlayable()
      this.checkTracker()
    })
  },
  methods: {
    checkIfPlayable () {
      this.allowPlaying = this.$el.classList.contains('in-viewport')
    },
    checkTracker () {
      if (this.$el.classList.contains('in-viewport', 'above-viewport')) {
        if (!this.tracked) {
          this.tracked = true
          trackSection(this.tracking.trackingId)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .game-section {
    max-width: 600px;
    margin: auto auto;
    padding: 50px 30px;
    color: $nos-op3-white;
  }

  .text {
    margin-bottom: 15px;
    font-size: 18px;
    line-height: 28px;
  }

  .text-end {
    margin: 25px 0;
  }

  .image-holder {
    text-align: center;
  }

  .image {
    width: 100%;
    height: auto;

    @include tablet {
      width: 70%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/sections/GameSection.vue